import React, { FC, type ReactNode, useRef, useState } from 'react';
import { DropdownContext } from './DropdownContext';
import { cn } from '../../utils/ui';

/**
 * DropdownMenu Props Interface.
 */
export interface DropdownMenuProps {
    children: ReactNode;
    className?: string;
}

/**
 * The root DropdownMenu component which holds the open state.
 */
export const DropdownMenu: FC<DropdownMenuProps> = props => {
    const { children, className = '' } = props;
    const [open, setOpen] = useState(false);
    // We'll capture the trigger element's ref to avoid closing when the trigger is clicked
    const triggerRef = useRef<HTMLElement>(null);

    return (
        <DropdownContext.Provider value={{ open, setOpen, triggerRef }}>
            <div className={cn('relative transition inline-block', className)}>{children}</div>
        </DropdownContext.Provider>
    );
};
